import { themeGet } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const Container = styled.ul `
  list-style: none;
  background-color: ${themeGet('colors.background.50')};
`;
